/**
 * @generated SignedSource<<d8391f88abcab0634622ba51ec005f6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LocationFeatureSource = "MAPBOX_V5" | "%future added value";
export type FormsUpdateResponseMutationInput = {
  answers: ReadonlyArray<AnswerInput>;
  clientMutationId?: string | null;
  responseId: string;
};
export type AnswerInput = {
  addressValue?: AddressValueInput | null;
  checkboxesGridValue?: CheckboxesGridValueInput | null;
  checkboxesValue?: CheckboxesValueInput | null;
  dateTimeValue?: DateTimeValueInput | null;
  dateValue?: DateValueInput | null;
  emailValue?: EmailValueInput | null;
  formattedTextValue?: FormattedTextValueInput | null;
  keywordsValue?: KeywordsValueInput | null;
  linkValue?: LinkValueInput | null;
  multipleChoiceGridValue?: MultipleChoiceGridValueInput | null;
  multipleChoiceValue?: MultipleChoiceValueInput | null;
  numericValue?: NumericValueInput | null;
  phoneNumberValue?: PhoneNumberValueInput | null;
  questionId: string;
  stringValue?: StringValueInput | null;
  timeValue?: TimeValueInput | null;
};
export type AddressValueInput = {
  value: AddressInput;
};
export type AddressInput = {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  countryCode?: any | null;
  locationFeature?: LocationFeatureInput | null;
  postalCode?: string | null;
  region?: string | null;
};
export type LocationFeatureInput = {
  data: string;
  source: LocationFeatureSource;
};
export type CheckboxesGridValueInput = {
  value: ReadonlyArray<string>;
};
export type CheckboxesValueInput = {
  value: ReadonlyArray<string>;
};
export type DateTimeValueInput = {
  value: ISO8601DateTimeString;
};
export type DateValueInput = {
  value: DateString ;
};
export type EmailValueInput = {
  value: string;
};
export type FormattedTextValueInput = {
  value: string;
};
export type KeywordsValueInput = {
  value: ReadonlyArray<string>;
};
export type LinkValueInput = {
  value: string;
};
export type MultipleChoiceGridValueInput = {
  value: ReadonlyArray<string>;
};
export type MultipleChoiceValueInput = {
  value: string;
};
export type NumericValueInput = {
  value: number;
};
export type PhoneNumberValueInput = {
  value: string;
};
export type StringValueInput = {
  value: string;
};
export type TimeValueInput = {
  value: TimeOfDayString;
};
export type RespondForm_updateResponse_Mutation$variables = {
  input: FormsUpdateResponseMutationInput;
};
export type RespondForm_updateResponse_Mutation$data = {
  readonly updateResponse: {
    readonly response: {
      readonly " $fragmentSpreads": FragmentRefs<"RespondForm_Response">;
    };
  } | null;
};
export type RespondForm_updateResponse_Mutation = {
  response: RespondForm_updateResponse_Mutation$data;
  variables: RespondForm_updateResponse_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RespondForm_updateResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsUpdateResponseMutationPayload",
        "kind": "LinkedField",
        "name": "updateResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RespondForm_Response"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RespondForm_updateResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsUpdateResponseMutationPayload",
        "kind": "LinkedField",
        "name": "updateResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "respondedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "responder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormResponseAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "questionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "text",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__String",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "number",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Numeric",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "checkboxes",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Checkboxes",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "multipleChoice",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__MultipleChoice",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "date",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Date",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "time",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Time",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "dateTime",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__DateTime",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "phoneNumber",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__PhoneNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "link",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Link",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "email",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomValue__Email",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f05d7af1cf0c65c85f2dd793e007ea9a",
    "id": null,
    "metadata": {},
    "name": "RespondForm_updateResponse_Mutation",
    "operationKind": "mutation",
    "text": "mutation RespondForm_updateResponse_Mutation(\n  $input: FormsUpdateResponseMutationInput!\n) {\n  updateResponse(input: $input) {\n    response {\n      ...RespondForm_Response\n      id\n    }\n  }\n}\n\nfragment RespondForm_Response on FormResponse {\n  id\n  state\n  respondedAt\n  responder {\n    name\n    id\n  }\n  answers {\n    id\n    questionId\n    value {\n      __typename\n      ... on CustomValue__String {\n        text: value\n      }\n      ... on CustomValue__Numeric {\n        number: value\n      }\n      ... on CustomValue__Checkboxes {\n        checkboxes: value\n      }\n      ... on CustomValue__MultipleChoice {\n        multipleChoice: value\n      }\n      ... on CustomValue__Date {\n        date: value\n      }\n      ... on CustomValue__Time {\n        time: value\n      }\n      ... on CustomValue__DateTime {\n        dateTime: value\n      }\n      ... on CustomValue__PhoneNumber {\n        phoneNumber: value\n      }\n      ... on CustomValue__Link {\n        link: value\n      }\n      ... on CustomValue__Email {\n        email: value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38f7eb8c5d6299c732627ad92bb91ffd";

export default node;
